import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";

const AlertModal = ({
  isOpen,
  modalTitle,
  modalMessage,
  primaryCaption,
  secondaryCaption,
  primaryClickHandler,
  dismissModalHandler,
  primaryButtonColour = "red",
  showIcon = true,
  isPrimaryLoading = false,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={dismissModalHandler}
      className="relative z-[60]"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-ink-900/40 backdrop-blur-sm transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-editorial data-leave:duration-200 data-leave:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-card bg-cream-50 text-left shadow-lift transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-editorial data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg data-closed:sm:translate-y-0 data-closed:sm:scale-95"
          >
            <div className="px-5 pt-6 pb-5 sm:p-7">
              <div className="sm:flex sm:items-start">
                {showIcon && (
                  <div className="mx-auto flex size-11 shrink-0 items-center justify-center rounded-full border border-signal-red-100 bg-signal-red-50 sm:mx-0 sm:size-10">
                    <ExclamationTriangleIcon
                      aria-hidden="true"
                      className="size-5 text-signal-red-500"
                    />
                  </div>
                )}
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <DialogTitle
                    as="h3"
                    className="font-display text-2xl text-ink-900"
                  >
                    {modalTitle}
                  </DialogTitle>
                  <div className="mt-2">
                    <div className="text-sm text-ink-600">{modalMessage}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-cream-100 border-t border-ink-100 px-5 py-3 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end sm:px-7">
              {secondaryCaption && (
                <SecondaryButton onClick={dismissModalHandler} colour="gray">
                  {secondaryCaption}
                </SecondaryButton>
              )}
              <PrimaryButton
                onClick={primaryClickHandler}
                colour={primaryButtonColour}
                disabled={isPrimaryLoading}
              >
                {primaryCaption}
              </PrimaryButton>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default AlertModal;
